<template>
    <div style="width:450px;background-color: #fff">
      <div style="display:flex;justify-content:space-between;">
        <div class="tabs"  :class="tabNum==='0'?'tabsActive':''" @click="tabNum='0';fetch('0')">试工</div>
        <div class="tabs"  :class="tabNum==='1'?'tabsActive':''" @click="tabNum='1';fetchTwo('1')">正式工</div>
      </div>
      <div style="display:flex;padding: 15px 10px;">
        <div style="margin-right:20px;">试工中 {{probationInProgress}}人</div>
        <div>转正申请 {{probationOnboardingReview}}人</div>
      </div>
      <div style="display:flex;justify-content:space-between;padding: 0 10px 15px;">
        <el-input size="small" v-model="userName" placeholder="请输入姓名" style="width:170px;"></el-input>
        <el-select size="small" v-model="jobStateList" multiple placeholder="请选择" style="width:170px;">
          <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-button size="small" type="primary" @click="()=>{
          if(tabNum==='0'){
            fetch()
          }else{
            fetchTwo()
          }
        }">查询</el-button>
      </div>
      <div v-loading="loading">
        <!-- 试工-->
        <div  v-if="tabNum==='0'" style="height:79vh;overflow-y: scroll">
          <div v-if="!temporaryList.length" style="text-align:center;margin-top:200px;color:#ccc;font-size:30px;">暂无数据</div>
          <div v-if="temporaryList.length">
            <div style="padding:0 10px;" v-for="(item,index) in temporaryList" :key="index">
              <div style="padding:10px;font-size: 14px" >
                <div style="display:flex;justify-content:space-between;">
                  <div style="width:270px;" @click="userCLick(item)">
                    <div style="display:flex;margin-bottom: 10px">
                       <el-tag size="small" v-if="item.jobState==='0'" style="margin-right:12px" >试工中</el-tag>
                       <el-tag size="small" v-if="item.jobState==='10'" type="warning" >转正审核中</el-tag>
                       <el-tag size="small" v-if="item.jobState==='-12' || item.jobState==='-10'" type="danger" >试工未通过</el-tag>
                    </div>
                    <div style="margin-bottom: 10px;font-size: 17px">{{item.userName}}</div>
                    <div style="margin-bottom: 10px">
                      <span>{{item.sex=='1' ? '男' : '女'}}</span>
                      <el-divider direction="vertical"></el-divider>
                      <span>{{item.age}}岁</span>
                      <el-divider direction="vertical"></el-divider>
                      <span>{{item.highestEducation}}</span>
                      <el-divider direction="vertical"></el-divider>
                      <span>{{item.maritalStatus}}</span>
                    </div>
                    <div style="margin-bottom: 10px">应聘职级：{{item.expectPostName}}</div>
                    <div style="margin-bottom: 10px">开始试工日期：{{item.probationDateStart}}</div>
                    <div style="margin-bottom: 10px" v-if="item.jobState=='-12' || item.jobState=='-10'">未通过类型：{{item.probationStateDesc}}</div>
                  </div>
                  <el-image
                      @click="checkImage(item.halfLengthPhoto)"
                      style="width: 130px; height: 170px"
                      :src="item.halfLengthPhoto"
                      v-if="item.halfLengthPhoto"
                  ></el-image>
                  <div class="diagonal-line" v-if="!item.halfLengthPhoto" >
<!--                    <div class="bias"></div>-->
<!--                    <div class="biasTwo"></div>-->
<!--                    <div class="nameBox">{{'缺失'}}</div>-->
                    <div>暂无图片</div>
                  </div>
                </div>
                <div style="margin-bottom: 10px; display:flex; justify-content:space-between;" v-if="item.jobState=='-12' || item.jobState=='-10'">
                  <div style="width:93px;margin:0;padding:0;">未通过原因：</div>
                  <div style="width:320px;margin:0;padding:0;">{{item.probationReason}}</div>
                </div>
                <div style="margin: 10px 0;text-align: right" >
                  <el-button v-if="item.jobState==='0'" type="danger" size="mini" @click="probationResign(item.onboardingApplyRecordId,item.userName,item.probationDateStart,'1')" >劝退</el-button>
                  <el-button v-if="item.jobState==='0'" type="warning" size="mini" @click="probationResign(item.onboardingApplyRecordId,item.userName,item.probationDateStart,'2')" >自离</el-button>
                  <el-button v-if="item.jobState==='0'" type="success" size="mini" @click="conversionApplicationForm(item.onboardingApplyRecordId,item.userName)" >转正</el-button>
                  <el-button :loading="loadingUserInfo" type="primary" size="mini" @click="userCLick(item)">试工信息</el-button>
                </div>
                <el-divider></el-divider>
              </div>
            </div>
          </div>
        </div>
        <!-- 正式-->
        <div v-if="tabNum==='1'" style="height:78vh;overflow-y: scroll">
          <div v-if="!formalList.length"  style="text-align:center;margin-top:200px;color:#ccc;font-size:30px;">暂无数据</div>
          <div v-if="formalList.length">
            <div style="padding:0 10px;" v-for="(item,index) in formalList" :key="index">
              <div style="padding:10px;font-size: 14px" >
                <div style="display:flex;justify-content:space-between;">
                  <div style="width:270px;" @click="userCLick(item)">
                    <div  style="display:flex;margin-bottom: 10px">
                       <el-tag size="small" v-if="item.jobState==='20'" >在职</el-tag>
                       <el-tag size="small" v-if="item.jobState==='30'" type="warning" style="margin-right:12px">离职审核中</el-tag>
                       <el-tag size="small" v-if="item.isCurLoginUserHasLeaveReview==='Y'" type="warning" style="margin-right:12px">待我审核</el-tag>
                       <el-tag size="small" v-if="item.jobState==='40'" type="warning" >离职审核中</el-tag>
                       <el-tag size="small" v-if="item.jobState==='50'" type="danger" >离职通过未到离职时间</el-tag>
                       <el-tag size="small" v-if="item.jobState==='-20'" type="info" >已离职</el-tag>
                    </div>
                    <div style="margin-bottom: 10px;font-size: 16px">{{item.userName}}</div>
                    <div style="margin-bottom: 10px">
                      <span>{{item.sex=='1' ? '男' : '女'}}</span>
                      <el-divider direction="vertical"></el-divider>
                      <span>{{item.age}}岁</span>
                      <el-divider direction="vertical"></el-divider>
                      <span>{{item.highestEducation}}</span>
                      <el-divider direction="vertical"></el-divider>
                      <span>{{item.maritalStatus}}</span>
                    </div>
                    <div style="margin-bottom: 10px">职级：{{item.postNames}}</div>
                    <div style="margin-bottom: 10px">联系电话：{{item.phone}}</div>
                  </div>
                  <el-image
                      @click="checkImage(item.halfLengthPhoto)"
                      style="width: 130px; height: 170px"
                      :src="item.halfLengthPhoto"
                      v-if="item.halfLengthPhoto"
                  ></el-image>
                  <div class="diagonal-line" v-if="!item.halfLengthPhoto" >
<!--                    <div class="bias"></div>-->
<!--                    <div class="biasTwo"></div>-->
<!--                    <div class="nameBox">{{'缺失'}}</div>-->
                    <div>暂无图片</div>
                  </div>
                </div>
                <div style="margin: 10px 0; display:flex; justify-content:space-between;">
                  <div style="font-size: 13px; ">{{item.hiredDate}} 入职</div>
                  <el-button :loading="loadingUserInfo" type="primary" size="mini" @click="userCLick(item)">员工信息</el-button>
                </div>
                <el-divider></el-divider>
              </div>
            </div>
          </div>
        </div>
      </div>

      <el-dialog :loading="loading" :title="titleName" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
        <div style="margin-bottom:20px;" v-if="!typeForm" >转正人：{{formUserName}}</div>
        <div style="margin-bottom:20px; display:flex;" v-if="typeForm" >
          <div>姓名：{{formUserName}}</div>
          <div style="margin-left:20px;">开始试工日期：{{probationDateStart}}</div>
        </div>
        <div style="margin-bottom:10px;" v-if="typeForm"><span style="color:red;">*</span>不通过类型</div>
        <el-input v-model="inputValue" disabled  v-if="typeForm" style="margin-bottom:20px;"></el-input>
        <div style="margin-bottom:10px;" v-if="!typeForm"><span style="color:red;">*</span>计划转正日期</div>
        <div style="margin-bottom:20px;" v-if="!typeForm">
          <el-date-picker
              placeholder="请选择日期"
              v-model="planHiredDate"
              type="date"
              size="small"
              value-format="yyyy-MM-dd"
              :clearable="false">
          </el-date-picker>
          <span style="margin-left:20px;color:#ccc">{{daysDiff}}</span>
        </div>
        <div style="margin-bottom:10px;" v-if="!typeForm"><span style="color:red;">*</span>转正说明</div>
        <div style="margin-bottom:10px;" v-if="typeForm"><span style="color:red;">*</span>具体原因</div>
        <el-input
            v-if="!typeForm"
            style="margin-bottom:20px;"
            type="textarea"
            :rows="5"
            placeholder="请输入转正的原因，如有优秀表现可额外补充。"
            v-model="reason">
        </el-input>
        <el-input
            v-if="typeForm"
            style="margin-bottom:20px;"
            type="textarea"
            :rows="5"
            placeholder="请输入具体原因。"
            v-model="reason">
        </el-input>
        <div style="margin-bottom:20px;" v-if="!typeForm">注意：提交后将交由人事审核，正式转正入职日期以人事填写的为准！</div>
        <div style="display:flex;justify-content: right">
          <el-button :loading="loading" @click="handleClose()">取 消</el-button>
          <el-button :loading="loading" type="primary" @click="submit()">确 定</el-button>
        </div>
      </el-dialog>
      <el-image-viewer class="image-view" v-if="showViewer" :on-close="closeViewer" :url-list="imageList" />
    </div>
</template>

<script>
  import 'mousetrap/plugins/global-bind/mousetrap-global-bind'
  import tool from '@/utils/tool.js'
  import newPostUrl from '@/libs/http/modules/oa.js'
  import moment from 'moment'
  import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

  export default {
    name:'userList',
    props: ['loadingUserInfo'],
    components: {
      ElImageViewer,
    },
    data() {
        return {
          tabNum:'1',
          loading:false,
          userName:'',
          jobStateList:[],
          options:[
            {label:'在职',value:'0'},
            {label:'离职审核中',value:'1'},
            {label:'待离职',value:'2'},
            {label:'已离职',value:'3'},
          ],
          temporaryList:[],
          formalList:[],
          probationInProgress:'',
          probationOnboardingReview:'',
          titleName:'',
          dialogVisible:false,
          onboardingApplyRecordId:'',
          formUserName:'',
          planHiredDate:'',
          reason:'',
          typeForm:'',
          probationDateStart:'',
          inputValue:'',
          daysDiff:'',
          showViewer: false,
          imageList: [],
        }
    },
    watch:{
      planHiredDate(){
        if(this.planHiredDate){
          this.daysDiff = this.friendlyTimeUpdate(this.planHiredDate)
        }
      },
      tabNum(){
        this.userName = ''
        this.jobStateList = []
        if(this.tabNum === '0'){
          this.options = [
            {label:'试工中',value:'0'},
            {label:'转正审核中',value:'1'},
            {label:'试工未通过',value:'2'},
          ]
          this.fetch()
        }else{
          this.options = [
            {label:'在职',value:'0'},
            {label:'离职审核中',value:'1'},
            {label:'待离职',value:'2'},
            {label:'已离职',value:'3'},
          ]
          this.fetchTwo()
        }
      },
    },
    created() {
      let tokenTime = tool.data.get('TOKEN_TIME')
      if(tool.data.get('TOKEN') && !this.hasExceededThirtyMinutes(tokenTime)){
        console.log('y有token了，来刷新')
        this.fetchTwo()
        this.queryOaFrontendJobStateCountByOrg()
      }else{
        //新接口调用需要的新token
        const newRequest = async () => {
          try {
            const result = await newPostUrl.newLogin()
            if (result) {
              console.log('result=================',result)
              await this.fetchTwo()
              this.queryOaFrontendJobStateCountByOrg()
            }
          } catch (error) {
            this.$message({ type: 'error', message: error.msg || error, duration: 2000, showClose: true })
          }
        }
        newRequest()
      }
    },
    methods: {
      // 判断是否超时30分钟
      hasExceededThirtyMinutes(tokenTime) {
        if(!tokenTime){
          return true
        }
        const THIRTY_MINUTES_MS = 30 * 60 * 1000; // 30分钟的毫秒数
        const currentTimestamp = Date.now(); // 当前时间戳
        const timeDifference = currentTimestamp - tokenTime; // 计算时间差
        return timeDifference >= THIRTY_MINUTES_MS; // 判断是否超过30分钟
      },
      userCLick(e){
        this.$emit('record',e)
      },
      queryOaFrontendJobStateCountByOrg(){
        newPostUrl.queryOaFrontendJobStateCountByOrg({
          orgId:tool.data.get('KEY_NEW_DEPT_ID')
        }).then(res=>{
          this.probationInProgress = res.probationInProgress
          this.probationOnboardingReview = res.probationOnboardingReview
        }).catch(err=>{
          console.log(err)
        })
      },

      friendlyTimeUpdate(e){
        let date1 = moment(e).format('YYYYMMDD')
        let date2 = moment(new Date()).format('YYYYMMDD')
        let num = this.calculateDaysBetweenDates(e,moment(new Date()).format('YYYY-MM-DD'))
        let monthNum = num / 30
        if(date1 < date2){
          if(num > 365){
            return `已超过1年前`
          }else if(num == 365){
            return `1年前`
          }else if(num >= 30 && num < 365){
            if(!Number.isInteger(monthNum)) {
              let monthNumMath = Math.floor(monthNum)
              let numDay = num - Math.floor(monthNum) * 30
              return `${monthNumMath}个月${numDay}天前`
            }else{
              return `${monthNum}个月前`
            }
          }else if(num < 30){
            return `${num}天前`
          }
        }
        if(date1 > date2){
          if(num > 365){
            return `已超过1年后`
          }else if(num == 365){
            return `1年后`
          }else if(num >= 30 && num < 365 ){
            if(!Number.isInteger(monthNum)){
              let monthNumMath =  Math.floor(monthNum)
              let numDay = num - Math.floor(monthNum)*30
              return `${monthNumMath}个月${numDay}天后`
            }else{
              return `${monthNum}个月后`
            }
          }else if(num < 30 && num < 365 ){
            return `${num}天后`
          }
        }
        if(date1==date2){
          return '今天'
        }
      },
      calculateDaysBetweenDates(date1, date2){
        // 将日期字符串转换为Date对象
        const startDate = new Date(date1);
        const endDate = new Date(date2);

        // 计算两个日期之间的毫秒差
        const timeDifference = endDate - startDate;

        // 将毫秒差转换为天数
        const dayDifference = timeDifference / (1000 * 3600 * 24);

        return Math.abs(dayDifference); // 返回绝对值，确保结果为正数
      },

      fetch(){
        let data={
          page:1,
          pageSize:100,
          orgId:tool.data.get('KEY_NEW_DEPT_ID'),
        }
        if(this.userName){
          data.userName = this.userName
        }
        if(this.jobStateList.length > 0){
          data.jobStateList = []
          this.jobStateList.forEach(item=>{
            if(item === '0'){
              data.jobStateList.push('0')
            }
            if(item === '1'){
              data.jobStateList.push('10')
            }
            if(item === '2'){
              data.jobStateList.push('-10')
              data.jobStateList.push('-12')
            }
          })
        }
        this.loading=true
        newPostUrl.queryFrontendProbationUserPage(data).then((res)=>{
          this.temporaryList = res.items || []
          if(res.items && res.items.length){
            this.userCLick(res.items[0])
          }
          this.loading=false
        }).catch((error)=>{
          this.loading=false
          if(error.msg){
            this.$message.error(error.msg)
          }else{
            this.$message.error(error)
          }
          console.log(error)
        })
      },
      fetchTwo(){
        let data={
          page:1,
          pageSize:100,
          orgId:tool.data.get('KEY_NEW_DEPT_ID'),
        }
        if(this.userName){
          data.userName = this.userName
        }
        if(this.jobStateList.length > 0){
          data.jobStateList = []
          this.jobStateList.forEach(item=>{
            if(item=='0'){
              data.jobStateList.push('20')
            }
            if(item=='1'){
              data.jobStateList.push('30')
              data.jobStateList.push('40')
            }
            if(item=='2'){
              data.jobStateList.push('50')
            }
            if(item=='3'){
              data.jobStateList.push('-20')
            }
          })
        }
        this.loading=true
        newPostUrl.queryFrontendRegularUserPage(data).then((res)=>{
          this.formalList = res.items || []
          if(res.items && res.items.length){
            this.userCLick(res.items[0])
          }
          this.loading=false
        }).catch((error)=>{
          this.loading=false
          if(error.msg){
            this.$message.error(error.msg)
          }else{
            this.$message.error(error)
          }
          console.log(error)
        })
      },

      handleClose(){
        this.dialogVisible = false
        this.typeForm = ''
        this.formUserName = ''
        this.onboardingApplyRecordId = ''
        this.probationDateStart = ''
        this.titleName = ''
        this.inputValue = ''
        this.reason = ''
        this.planHiredDate = ''
        this.daysDiff = ''
      },
      conversionApplicationForm(onboardingApplyRecordId,userName){
        this.typeForm = ''
        this.dialogVisible = true
        this.formUserName = userName
        this.onboardingApplyRecordId = onboardingApplyRecordId
        this.titleName = '转正申请'
      },
      probationResign(onboardingApplyRecordId,userName,probationDateStart,e){
        this.typeForm = e
        this.dialogVisible = true
        this.formUserName = userName
        this.probationDateStart = probationDateStart
        this.onboardingApplyRecordId = onboardingApplyRecordId
        if(e=='1'){
          this.titleName = '劝退'
          this.inputValue = '劝退'
        }else if(e=='2'){
          this.titleName = '自离'
          this.inputValue = '自离'
        }
      },

      submit(){
        if(this.typeForm){
            if(!this.reason)return this.$message.error('请输入具体原因')
            this.loading = true;
            let data = {
              onboardingApplyRecordId:this.onboardingApplyRecordId,
              reason:this.reason
            }
            if(this.typeForm=='1'){
              data.trialState = '-10'
            }else if(this.typeForm=='2'){
              data.trialState = '-12'
            }
            newPostUrl.reviewUserTrialWorkRefuse(data).then((res)=>{
              this.loading = false;
              this.handleClose()
              this.$message.success('操作成功')
              setTimeout(()=>{
                this.fetch()
              },500)
            }).catch(error=>{
              this.loading = false;
              if(error.msg){
                this.$message.error(error.msg)
              }else{
                this.$message.error(error)
              }
              console.log(error)
            })
        }else{
            if(!this.planHiredDate)return this.$message.error('请选择计划转正日期')
            if(!this.reason)return this.$message.error('请输入转正说明')
            this.loading = true;
            let data = {
              planHiredDate:this.planHiredDate,
              onboardingApplyRecordId:this.onboardingApplyRecordId,
              regularizationRemark:this.reason
            }
            newPostUrl.reviewUserTrialWorkAgree(data).then((res)=>{
              this.loading = false;
              this.handleClose()
              this.$message.success('操作成功')
              setTimeout(()=>{
                this.fetch()
              },500)
            }).catch((error)=> {
              this.loading = false;
              if(error.msg){
                this.$message.error(error.msg)
              }else{
                this.$message.error(error)
              }
              console.log(error)
            })

        }


      },

      checkImage(e){
        this.imageList = []
        this.imageList.push(e)
        this.showViewer=true
      },
      closeViewer(){
        this.showViewer = false
      },

    }
  }
</script>

<style lang="scss" scoped>
  .tabs{
    width:225px;
    text-align: center;
    height:40px;
    line-height: 35px;
    color:#1684fc;
    background-color: #ffffff;
    border: 3px solid #1684fc;
  }
  .tabsActive{
    color:#ffffff;
    background-color:#1684fc ;
  }
  .diagonal-line{
    width:130px;
    height:170px;
    background-color: #f7f7f7;
    text-align: center;
    line-height: 170px;
    // border:1px solid #989898;
    // border-radius:5px;
    // display:flex;
    // align-items: center;
    // justify-content: center;
    // position:relative;
  }
  .nameBox{
    position: absolute;
    top:40%;
    left:32%;
    font-size:25px;
    color:#989898;
  }
  .bias{
    width: 2px;
    height: 200px;
    background-color: #989898;
    // border-top: 2px solid #f06;
    transform: rotate(-36deg);
  }
  .biasTwo{
    width: 2px;
    height: 200px;
    background-color: #989898;
    // border-top: 2px solid #f06;
    transform: rotate(-144deg);
  }
  .image-view {
    z-index: 99999 !important;
  }
  .el-image-viewer {
    z-index: 99999 !important;
  }
</style>
